import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch, CircularProgress } from 'lib/@mui';

import { Tooltip } from 'components';
import { useTranslate } from 'features/languages';
import { ADVANCED_SCENES } from 'constants/ControllerFeatures';
import { EZLOGIC_TITLE_STATUS_MESHBOT_FROM_ADVANCED_SCENE_1_74 } from 'constants/language_tokens';
import { shouldDisableSystemTcdsActions } from 'containers/Ezlo/EzloMeshbot/utils';
import { MESHBOT_TYPES } from '../../containers/Ezlo/EzloMeshbots/constants';
import { getUpdateMeshBotStatusThunk } from './utils';

import './style.scss';

const MeshbotSwitch = ({ renderedCellValue: params }) => {
    const [isPending, setIsPending] = useState(false);
    const dispatch = useDispatch();
    const { t } = useTranslate();
    const ezloData = useSelector((state) => state.ezlo?.data?.[params?.serial]);
    const isTcdsDisabled = shouldDisableSystemTcdsActions(params, ezloData, ADVANCED_SCENES.VERSION_1_74);
    const isDisabledSwitchBtn = params && params.isDisabled;
    const isEzlopiType = params.type === MESHBOT_TYPES.EZLOPI;

    const handleChange = (event) => {
        if (isPending) {
            return;
        }

        const updateMeshBotStatus = getUpdateMeshBotStatusThunk(params, event.target.checked);
        if (!updateMeshBotStatus) {
            return;
        }

        setIsPending(true);
        dispatch(updateMeshBotStatus).finally(() => setIsPending(false));
    };

    return (
        <div className="switch-wrapper">
            <Tooltip
                title={
                    isTcdsDisabled && (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: t(EZLOGIC_TITLE_STATUS_MESHBOT_FROM_ADVANCED_SCENE_1_74),
                            }}
                        />
                    )
                }
                position="top"
            >
                <div>
                    <Switch
                        size="medium"
                        disabled={isDisabledSwitchBtn || isEzlopiType || isTcdsDisabled || isPending}
                        checked={Boolean(params?.enabled)}
                        onChange={handleChange}
                        color="primary"
                        name="switcher"
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                    {isPending && <CircularProgress className="switch-pending-progress" size={36} />}
                </div>
            </Tooltip>
        </div>
    );
};

export default MeshbotSwitch;
